<template>
	<div class="login">
		<div class="loginBox">
			<h3 class="title">知临校园</h3>
			<el-form ref="form">
				<el-form-item>
					<el-input v-model="username" placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="password" type="password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item class="el-form-item-s">
					<el-radio label="记住我的账号密码" v-model="radio" @click.native.prevent="onRadioChange('记住我的账号密码')"></el-radio>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="formBtn" @click="login">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="footer">
			<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022100216号-1</a>
		</div>
	</div>
</template>

<script>
	const Base64 = require('js-base64').Base64;
	import { loginApi} from "@/axios/api";
	export default {
	    name: "Login",
		data() {
			return {
				radio: '0',
				password:'',
				username:''
			}
		},
		created() {
			let username = this.getCookie("username")
			let password = Base64.decode(this.getCookie("password"))
			if(username){
				this.username = username;
				this.password = password;
			}
		},
		methods: {
			onRadioChange(e){
				if (this.radio === e) {
					this.radio = '0'
					return
				}
				this.radio = e
			},
			//登录
			async login() {
				if(this.username == ''){
					this.$message({
						message: '请输入账号',
						type: 'warning'
					});
					return false
				}
				if(this.password == ''){
					this.$message({
						message: '请输入密码',
						type: 'warning'
					});
					return false
				}
				try {
					let res = await loginApi({
						username:this.username,
						password:this.password
					});
					if (res.code === 200) {
						this.$message({
							message: '登录成功！',
							type: 'success'
						});
						localStorage.setItem('Authorization',res.data);
						this.setUserInfo();
						this.$router.push({path: '/schoolList'});
					}
				} catch (error) {
					console.log(error)
				}
			},
			// 储存表单信息
			setUserInfo: function () {
				if(this.radio !== 0){
					this.setCookie("username",this.username);
					let passWord = Base64.encode(this.password);
					this.setCookie("password",passWord);
				}else{
					this.setCookie("username","");
					this.setCookie("password","");
				} 
			},
			// 获取cookie
			getCookie: function (key) {
				if (document.cookie.length > 0) {
					var start = document.cookie.indexOf(key + '=')
					if (start !== -1) {
						start = start + key.length + 1
						var end = document.cookie.indexOf(';', start)
						if (end === -1) end = document.cookie.length
						return unescape(document.cookie.substring(start, end))
					}
				}
				return ''
			},
			// 保存cookie
			setCookie: function (cName, value, expiredays) {
				var exdate = new Date()
				exdate.setDate(exdate.getDate() + expiredays)
				document.cookie = cName + '=' + decodeURIComponent(value) +
				((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
			},
		}
	}
</script>

<style lang="less" scoped>
	.login{
		width: 100%;
		height: 100vh;
		background: url('../assets/loginbg.png') no-repeat;
		background-size: cover;
		.loginBox{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 350px;
			.title{
				margin: 10px 0 40px 0;
				font-size: 24px;
			}
			.formBtn{
				width: 100%;
			}
		}
	}
	.el-form-item-s{
		margin-bottom: 10px;
		margin-top: -12px;
	}
	.footer{
		position: fixed;
		left:0;
		bottom:0;
		width:100%;
		line-height: 50px;
		a{
			color: #7c878f;
			text-decoration: none;
			font-size:16px;
		}
	}
</style>